import type {JSONValue} from 'types';
import {getOffset} from 'services/utils/getOffset';
import type {AgentSearchProps, SearchProps} from '../types';
import agentQuery from '../data/agentQuery.json';
import {normalizeQuery} from '../functions';

const AGENT_INDEX = 'ebs-agent-alias';

export const mapAgentSearchPropsToSearchProps = ({
  query,
  agentType,
  page,
  size,
  abortSignal,
}: AgentSearchProps): SearchProps => {
  const normalizedQuery = normalizeQuery(query);
  const from = getOffset(page, size);

  const elasticBody = JSON.parse(
    JSON.stringify(agentQuery)
      .replaceAll('${QUERY_PLACEHOLDER}', normalizedQuery)
      .replaceAll('${AGENT_TYPE_PLACEHOLDER}', agentType.toUpperCase())
      .replaceAll('"${FROM_PLACEHOLDER}"', String(from))
      .replaceAll('"${SIZE_PLACEHOLDER}"', String(size)),
  ) as JSONValue;

  return {
    target: '_search',
    index: AGENT_INDEX,
    elasticBody,
    abortSignal,
  };
};
